jQuery(function ($) {
  if ($(".agence-equipe").length) {
    if ($(window).width() > 767) {
      $(".agence-equipe .membre img").each(function (index) {
        $(this).mouseenter(function () {
          $(".agence-equipe .membre").addClass("inactive");
          $(this).parent(".membre").removeClass("inactive");
          $(this).parent(".membre").addClass("active");
        });
        $(this).mouseleave(function () {
          $(".agence-equipe .membre").removeClass("inactive");
          $(".agence-equipe .membre").removeClass("active");
        });
      });
    }
  }
});
